<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre4">Introduction: Living Wisely with the Church Fathers</a></div>
<div class="SOM_pre"><a href="#/pre5">Abbreviations</a></div>
<div class="SOM_chap"><a href="#/p1chap1">1 “They Looked like Flaming Angels”: Martyrdom</a></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample">2 “A Solid Drop of Gold”: Wealth and Poverty</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample">3 “The Misery of These Evils”: War and Military Service</span></div>
<div class="SOM_chap"><span href="#/p4chap1" title="Link target outside of Sample">4 “The Closest of Relationships”: Sex and the Dynamics of Desire</span></div>
<div class="SOM_chap"><span href="#/p5chap1" title="Link target outside of Sample">5 “One Hope, One Desire, One Way of Life”: Life as Male and Female, and the Goodness and Beauty of Marriage</span></div>
<div class="SOM_chap"><span href="#/p6chap1" title="Link target outside of Sample">6 “From the Cradle to the Grave”: Life and Death</span></div>
<div class="SOM_chap"><span href="#/p7chap1" title="Link target outside of Sample">7 “Let the Races Begin!”: Entertainment</span></div>
<div class="SOM_chap"><span href="#/p8chap1" title="Link target outside of Sample">8 Learning to Live a Good Life with God:<br/>The Well-Ordered Heart</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Name and Subject Index</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Praise for <i>Living Wisely with the Church Fathers</i></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?71ae453c